import * as _composablepolkadot from './composablepolkadot';
const ibc = [..._composablepolkadot.ibc_chain1];
export default ibc;
